import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MainComponent } from './containers/main/main.component';
import { HeaderComponent } from './components/header/header.component';
import { NotificationComponent } from './components/notification/notification.component';
import { SearchComponent } from './components/search/search.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { MenuComponent } from './components/menu/menu.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ModalComponent } from './components/modal/modal.component';
import { ToggleComponent } from './controls/toggle/toggle.component';
import { TariffButtonsComponent } from './controls/tariff-buttons/tariff-buttons.component';
import { FooterComponent } from './components/footer/footer.component';
import { UINotificationComponent } from './components/ui-notification/ui-notification.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SortHeaderComponent } from './components/sort-header/sort-header.component';
import { HistoryComponent } from './components/history/history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressFormComponent } from './forms/address-form/address-form.component';
import { BasicLookupComponent } from './components/basic-lookup/basic-lookup.component';
import { SelectComponent } from './components/select/select.component';
import { OptionComponent } from './components/select/option.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OptionPipe } from './components/select/option.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CreateBasicLookupComponent } from './containers/create-basic-lookup/create-basic-lookup.component';
import { BasicLookupDetailComponent } from './containers/basic-lookup-detail/basic-lookup-detail.component';

@NgModule({
  declarations: [
    MainComponent,
    HeaderComponent,
    NotificationComponent,
    SearchComponent,
    UserInfoComponent,
    MenuComponent,
    ProgressBarComponent,
    ModalComponent,
    ToggleComponent,
    TariffButtonsComponent,
    FooterComponent,
    UINotificationComponent,
    PaginationComponent,
    SortHeaderComponent,
    HistoryComponent,
    AddressFormComponent,
    BasicLookupComponent,
    SelectComponent,
    OptionComponent,
    OptionPipe,
    CreateBasicLookupComponent,
    BasicLookupDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    BrowserAnimationsModule,
    TranslateModule
  ],
  exports: [
    ModalComponent,
    ToggleComponent,
    TariffButtonsComponent,
    PaginationComponent,
    SortHeaderComponent,
    HistoryComponent,
    AddressFormComponent,
    BasicLookupComponent,
    SelectComponent,
    OptionComponent,
    OptionPipe,
    CreateBasicLookupComponent,
    BasicLookupDetailComponent
  ]
})
export class CoreModule { }
